module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.display) ? _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.isTabActive['tab1']
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActiveTab('tab1')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('lbl_tab_dashboard')) + "\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isTabActive['tab2']
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActiveTab('tab2')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('lbl_tab_management')) + "\n            ")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.can("god4all.admin.user.client")),
      expression: "can(\"god4all.admin.user.client\")"
    }],
    class: {
      active: _vm.isTabActive['tab3']
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActiveTab('tab3')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('menu_main_user_list')) + "\n            ")])]), _vm._v(" "), (_vm.client.useCustomers) ? _c('li', {
    class: {
      active: _vm.isTabActive['tab4']
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setActiveTab('tab4')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.getTranslation('menu_main_customer_list')) + "\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.isTabActive['tab3']) ? _c('div', {
    staticClass: "row client-details-wrapper"
  }, [_c('user-list', {
    attrs: {
      "client": _vm.client,
      "hideTitle": "true"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTabActive['tab2']) ? _c('div', {
    staticClass: "row client-details-wrapper"
  }, [_c('call-settings', {
    attrs: {
      "client": _vm.client
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTabActive['tab2']) ? _c('div', {
    staticClass: "row client-details-wrapper"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('table', {
    staticClass: "table table-striped table-condensed"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/history/files",
      "activeClass": "active",
      "tag": "button",
      "title": _vm.getTranslation('lbl_history_sounds')
    }
  }, [_c('i', {
    staticClass: "fa fa-history",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_hotlineNumber')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.client.hotlineNumber))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_onDutyFile')))]), _vm._v(" "), _c('td', [(_vm.client.onDutyFile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                " + _vm._s(_vm.client.onDutyFile) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview0'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview0')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview0'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview0",
    attrs: {
      "id": "audio_onDutyFile",
      "src": _vm.filePath + 'getondutyfile'
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview0')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        _vm.showConfirmDialog('onDutyFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_offDutyFile')))]), _vm._v(" "), _c('td', [(_vm.client.offDutyFile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                " + _vm._s(_vm.client.offDutyFile) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview1'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview1')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview1'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview1",
    attrs: {
      "id": "audio_offDutyFile",
      "src": _vm.filePath + 'getoffdutyfile'
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview1')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        _vm.showConfirmDialog('offDutyFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_disturbFile')))]), _vm._v(" "), _c('td', [(_vm.client.disturbFile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                " + _vm._s(_vm.client.disturbFile) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview2'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview2')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview2'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview2",
    attrs: {
      "id": "audio_disturbFile",
      "src": _vm.filePath + 'disturb'
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview2')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        _vm.showConfirmDialog('disturbFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_helpFile')))]), _vm._v(" "), _c('td', [(_vm.client.helpFile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                " + _vm._s(_vm.client.helpFile) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview3'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview3')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview3'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview3",
    attrs: {
      "id": "audio_helpFile",
      "src": _vm.filePath + 'helptext'
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview3')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        _vm.showConfirmDialog('helpFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_acceptedFile')))]), _vm._v(" "), _c('td', [(_vm.client.acceptedFile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                " + _vm._s(_vm.client.acceptedFile) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview4'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview4')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview4'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview4",
    attrs: {
      "id": "audio_acceptedFile",
      "src": _vm.filePath + 'accepted'
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview4')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        _vm.showConfirmDialog('acceptedFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_deniedFile')))]), _vm._v(" "), _c('td', [(_vm.client.deniedFile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                " + _vm._s(_vm.client.deniedFile) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview5'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview5')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview5'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview5",
    attrs: {
      "id": "audio_deniedFile",
      "src": _vm.filePath + 'denied'
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview5')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        _vm.showConfirmDialog('deniedFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_invalidFile')))]), _vm._v(" "), _c('td', [(_vm.client.invalidFile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                " + _vm._s(_vm.client.invalidFile) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview6'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview6')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview6'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview6",
    attrs: {
      "id": "audio_invalidFile",
      "src": _vm.filePath + 'invalid'
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview6')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        _vm.showConfirmDialog('invalidFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()])]), _vm._v(" "), (_vm.client.useCustomers) ? _c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_client_inputCode')))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        " + _vm._s(_vm.client.codeFile) + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": _vm.getTranslation(_vm.playStopTooltip('audioPreview7'))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playRecord('audioPreview7')
      }
    }
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.audioPreviewClass('audioPreview7'),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "audioPreview7",
    attrs: {
      "id": "audio_enterCode",
      "src": _vm.filePath + 'code'
    },
    on: {
      "ended": function($event) {
        _vm.stopRecord('audioPreview7')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": _vm.getTranslation('lbl_delete')
    },
    on: {
      "click": function($event) {
        _vm.showConfirmDialog('codeFile')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.getTranslation('lbl_upload_files')))]), _vm._v(" "), _c('banet-upload', {
    ref: "fileUpload",
    attrs: {
      "autoUpload": false
    },
    on: {
      "setFiles": _vm.setFiles,
      "tempFiles": _vm.setTempFiles
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isTabActive['tab1']) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.timeplanDisplay) ? _c('timeplan-block', {
    attrs: {
      "client": _vm.client
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isTabActive['tab1']) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.contactsDisplay) ? _c('contacts-block', {
    attrs: {
      "client": _vm.client
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isTabActive['tab1']) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.ticketsDisplay) ? _c('tickets-block', {
    attrs: {
      "client": _vm.client
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isTabActive['tab4']) ? [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.customerDisplay) ? _c('customer-block', {
    attrs: {
      "client": _vm.client
    }
  }) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), _c('banet-modal-confirm', {
    attrs: {
      "show": _vm.showConfirm,
      "showFooter": true,
      "title": _vm.getTranslation('modalTitle'),
      "body": _vm.getTranslation('someText')
    },
    on: {
      "confirmNo": _vm.unconfirm,
      "confirmYes": _vm.confirm
    }
  }), _vm._v(" "), _c('banet-modal-confirm', {
    attrs: {
      "show": _vm.showConfirmDelete,
      "showFooter": true,
      "title": _vm.getTranslation('modal_confirm_title'),
      "body": _vm.getTranslation('label_confirm_client_file_delete')
    },
    on: {
      "confirmNo": function($event) {
        _vm.confirmDelete(false)
      },
      "confirmYes": function($event) {
        _vm.confirmDelete(true)
      }
    }
  }), _vm._v(" "), _c('banet-modal-info', {
    attrs: {
      "show": _vm.show,
      "showFooter": true,
      "title": ' ',
      "body": 'Your answer is ' + _vm.answer
    },
    on: {
      "infoClose": _vm.closeModalInfo
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64deef34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/public/components/home/Home.vue
// module id = 684
// module chunks = 0